import { useState, useEffect } from "react";
import helpers from "@/utils/helpers";
import { decodeB64 } from "@/utils/Utils";
import { CANAL_APP, CROSS_SELLING_APP } from "@/constants/embbed";
import { ONESTEP_VCD } from "@/constants/one-step";

export const useEmbedded = () => {
  const [tipoDocumentoApp, setTipoDocumento] = useState("");
  const [nroDocumentoApp, setNroDocumento] = useState("");
  const [celularApp, setCelularApp] = useState("");
  const [canalApp, setCanalApp] = useState("");
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [isCrossSelling, setIsCrossSelling] = useState(false);
  const [isOneStep, setIsOneStep] = useState(false);
  const urlEmbedded = sessionStorage.getItem("urlEmbedded");
  const customUtm = urlEmbedded ? urlEmbedded.substring(1) : "";
  const campaign = helpers.getCampaign();
  const { origenContenido } = campaign;
  const silentOneStep = JSON.parse(localStorage.getItem(ONESTEP_VCD));

  const hasValidParameter = (utm, paramName) => {
    const value = helpers.getParameterValue(paramName, utm);
    return value !== null && value !== "";
  };

  useEffect(() => {
    const tipoDocumento = decodeB64(
      helpers.getParameterValue("tipoDocumento", customUtm)
    );
    const nroDocumento = decodeB64(
      helpers.getParameterValue("nroDocumento", customUtm)
    );
    const celular = decodeB64(helpers.getParameterValue("celular", customUtm));
    const canal = decodeB64(helpers.getParameterValue("canal", customUtm));
    const isEmbedded =
      tipoDocumento && nroDocumento && canal && canal === CANAL_APP;
    if (isEmbedded) {
      setTipoDocumento(tipoDocumento);
      setNroDocumento(nroDocumento);
      setCelularApp(celular);
      setCanalApp(canal);
      setIsEmbedded(true);
    }
    if (origenContenido.includes(CROSS_SELLING_APP)) {
      setIsCrossSelling(true);
    }
    if (hasValidParameter(customUtm, "id") || silentOneStep) {
      setIsOneStep(true);
    }
  }, []);

  return {
    isEmbedded,
    tipoDocumentoApp,
    nroDocumentoApp,
    celularApp,
    canalApp,
    isCrossSelling,
    isOneStep
  };
};
